module.exports = __webpack_public_path__ + "img/anak-benih-sawit.21afa75c.jpeg";